<template>
    <!-- <AdminLayout> -->
        <section class="flex items-start">
            <div class="w-full">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between mb-5">
                            <p class="font-semibold text-xl text-neutral-800">Attendance Report</p>
                            
                            <div class="flex items-center space-x-4">                              
                                <div class="ml-auto" v-if="userType === 'admin'">  
                                    <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                                    <select class="border rounded-lg px-2 py-2 text-sm" v-model="slectedLocation" @change="getAttendanceLeaveSummary">  
                                        <option value="">Location</option>
                                        <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                                <p class="text-sm leading-none font-medium text-black moth-bxd flex items-center border rounded-lg pl-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                                        <path fill="#cfd8dc" d="M5 38V14h38v24c0 2.2-1.8 4-4 4H9c-2.2 0-4-1.8-4-4"/>
                                        <path fill="#f44336" d="M43 10v6H5v-6c0-2.2 1.8-4 4-4h30c2.2 0 4 1.8 4 4"/>
                                        <g fill="#b71c1c"><circle cx="33" cy="10" r="3"/><circle cx="15" cy="10" r="3"/></g>
                                        <path fill="#b0bec5" d="M33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2M15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2"/>
                                        <path fill="#90a4ae" d="M13 20h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm-18 6h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4zm6 0h4v4h-4z"/>
                                    </svg>
                                    <month-picker-input 
                                    v-model="filterMonth" 
                                    :no-default="true" 
                                    @change="logEffectiveFrom"
                                    :placeholder="'Select Month'"
                                    />
                                </p>

                                <!-- <Datepicker v-model="date" placeholder="Select a date" /> -->
                                
                            </div>
                        </div>

                        <!-- <div class="flex mb-8 items-center bg-neutral-300/50 rounded-md p-1">
                            <div class="w-96 mx-3 ml-auto">
                                <input type="search" name="" id="" class="w-full rounded-full bg-white text-sm px-6 py-3 outline-none block font-normal" placeholder="Search...">
                            </div>
                            <div>
                                <button class="btn-primary"> Download <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2">
                                    <path fill="currentColor" d="M12 4v12.25L17.25 11l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 16.25V4zM3 19h1v2h15v-2h1v3H3z"></path></svg>
                                </button>
                            </div>
                        </div> -->

                        <div >
                            <div v-if="isLoading">
                                <div class="grid grid-cols-10 bg-[#ECF6FF] divide-x-[1px] divide-white rounded-md animate-pulse">
                                    <div class="px-3 py-2 font-semibold" v-for="i in 10" :key="i">
                                        <span class="w-full block rounded h-5 bg-neutral-300"></span>
                                    </div>
                                </div>
                                <div class="grid grid-cols-10 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="i in 8" :key="i">
                                    <div class="px-2 py-2" v-for="i in 10" :key="i">
                                        <span class="w-full block rounded h-5 bg-neutral-200"></span>
                                    </div>
                                </div>
                               
                            </div>
                            <div v-else>
                                <div v-if="recordList.length > 0">
                                    <div class="overflow-x-auto">
                                        <div class="min-w-[1700px]">
                                            <div class="grid grid-cols-10 bg-[#ECF6FF] divide-x divide-[#eaeaea]">
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2">Employee Name</div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Employee ID</div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Days Present</div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal col-span-2 justify-center">Leaves Details</div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Date Of Joining </div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Position</div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal">Contact No</div>
                                                <div class="text-sm leading-none px-2 py-3 text-[#404A5A] flex items-center font-normal justify-center">Action</div>
                                            </div>
                                            <div v-for="(employee, index) in recordList" :key="index" class="grid grid-cols-10 bg-white divide-x divide-y divide-[#eaeaea]">
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-2 border-t border-[#eaeaea]">
                                                    {{ employee.employee_name }}
                                                </div>
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                                    {{ employee.employee_id }}
                                                </div>
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                    {{ employee.total_present_days }}
                                                </div>
                                                <div class="px-2 py-1 col-span-2">
                                                    <table class="glob_table">
                                                        <thead class="bg-[#ECF6FF]">
                                                            <tr>
                                                                <th class="text-[11px] leading-none p-2 font-semibold">Name</th>
                                                                <th class="text-[11px] leading-none p-2 font-semibold">Total Leave</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="employee.leave_details.length > 0">
                                                            <tr v-for="(leave, index) in employee.leave_details" :key="index">
                                                                <td class="px-2 py-2 text-xs font-normal" >
                                                                    {{ leave.leave_name }}                                                          
                                                                </td>
                                                                <td class="px-2 py-2 text-xs font-normal">{{ leave.total_days }}    </td>
                                                            </tr>
                                                        </tbody>
                                                        <div v-else class="text-sm leading-none px-2 py-3">
                                                            No leaves taken
                                                        </div>
                                                    </table>
                                                </div>
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                                    {{ formatDate(employee.doj) }}
                                                </div>
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                                    {{ employee.designation }}
                                                </div>
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                                    {{ employee.contact_no }}
                                                </div>
                                                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                    <router-link :to="'/attendance-details/'+employee.uid" class="inline-flex items-center justify-center bg-blue-400 rounded-md px-3 pt-2 pb-1.5 text-white text-xs font-normal">View Details</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex pt-5 justify-end">
                                        <MultiPageComponent :page="pageData?.page" :totalPages="pageData?.totalPages"
                                        @page-change="handlePageChange" />
                                    </div>
                                </div>
                                <div v-else class="text-center py-5 text-gray-500">
                                    No records found.
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
            <!-- <RightSideBar /> -->
        </section>
    <!-- </AdminLayout> -->
</template>

<script>
import MultiPageComponent from "../../components/Widgets/MultiPageComponent.vue";
import { MonthPickerInput } from 'vue-month-picker'
import { createLocal } from 'the-storages';
import axios from "axios";
import { BASE_URL } from "../../config";

const mirror = createLocal();
const storage = mirror._prx;
import moment from "moment";

export default {
    name: 'AttendanceAdjustment',
    components: {
        // AdminLayout,
        // RightSideBar,
        MonthPickerInput,
        MultiPageComponent,
    },
    
    data() {
        return {
            storage: storage,      
            filterMonth: new Date(),
            recordList: [],
            currentPage: 1,
            pageData: {},
            isLoading: false,
            branchList: [],  
            slectedLocation: '',   
            userType: '',  
            globalDateFormat: '',   
        };
    },
  
    mounted() {
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');  
        const year = now.getFullYear();
        this.filterMonth = `${year}-${month}`;
        if (this.storage.userType === 'Super Admin') {               
            this.slectedLocation = ''; // Set to an empty string or a default value
            this.userType = 'admin';
        } else {
            this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
            this.userType = 'not-admin';
            console.log('branch', this.slectedLocation);
        }
        this.currentPage = this.$route.query.page ? this.$route.query.page : 1;
        this.getAttendanceLeaveSummary();
        this.getBranchList();
        this.globalDateFormat = localStorage.getItem("globalDateFormat");
    },
    methods: {
        async getAttendanceLeaveSummary() {
            this.isLoading = true; // ✅ Start loader

            try {
                console.log('month', this.filterMonth);
                const formData = {
                    company_id: this.storage.companyDetails.id,
                    month: this.filterMonth,
                    page: this.currentPage,
                    limit: 6,
                    location: this.slectedLocation,
                };
                console.log("FORM DATA: ", formData);

                const response = await axios.post(BASE_URL + '/get-attendance-leave-summary', formData);
                
                this.recordList = response.data.recordTotal;
                this.pageData = response.data.pagination;
                console.log("ATTENDANCE LEAVE SUMMARY:: ", response.data);

            } catch (error) {
                console.error("Error fetching attendance leave summary:", error);
            } finally {
                this.isLoading = false; // ✅ Stop loader
            }
        },
        logEffectiveFrom(value) {
            console.log("Effective From Changed:", value);
            this.filterMonth = `${value.year}-${String(value.monthIndex).padStart(2, '0')}`;
            this.getAttendanceLeaveSummary();
        },
        handlePageChange(newPage) {
            if (this.$route.query.page === newPage) return
            const query = { ...this.$route.query }
            if (newPage) query.page = newPage
            else delete query.page
            this.$router.replace({ query })
            this.currentPage = newPage;
            this.getAttendanceLeaveSummary();
        },
        async getBranchList() {
            const formData = {
                "company_id":this.storage.companyDetails.id
            };
            await axios.post(BASE_URL + '/get-emp-branch-list',formData)
            .then((response)=>{
                this.branchList =  response.data.branchDetails;
                console.log("Role LIST:: ",response.data);
            })
        },
        formatDate(date) {
            if (!date) return '';
            return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
        },
    }

};
</script>
<style>
.moth-bxd .month-picker-input{
    width: 100%;
    border: none !important;
}
.month-picker-input-container .month-picker__container{
    right: 0;
}
</style>